import { ChangeDetectionStrategy, Component } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import {
  SiteAnnouncementsEntity,
  SiteAnnouncementsFacade,
  TargetTypeEnum,
} from 'libs/gb-dashboard/staff/data-access-site-announcements/src'
import * as SiteAnnouncementsActions from 'libs/gb-dashboard/staff/data-access-site-announcements/src/lib/+state/site-announcements.actions'
import { of, tap } from 'rxjs'

@Component({
  selector: 'gb-create-site-announcement-dialog',
  templateUrl: './gb-create-site-announcement-dialog.component.html',
  styleUrls: ['./gb-create-site-announcement-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GbCreateSiteAnnouncementDialogComponent {
  editCreateLoaded$ = this.siteAnnouncementsFacade.editCreateLoaded$
  targetOptions$ = of([
    { name: 'SITE_ANNOUNCEMENTS.DIALOG.ALL', value: TargetTypeEnum.All },
    { name: 'SITE_ANNOUNCEMENTS.DIALOG.NON', value: TargetTypeEnum.NonSaas },
    { name: 'SITE_ANNOUNCEMENTS.DIALOG.SAAS', value: TargetTypeEnum.Saas },
  ])

  title = new FormControl('', [Validators.required])
  preamble = new FormControl('', [Validators.required])
  content = new FormControl('', [Validators.required])
  target = new FormControl(TargetTypeEnum.All, [Validators.required])
  display = new FormControl(false)
  publish_date = new FormControl<string | null>('')
  display_until = new FormControl<string | null>('')

  createSiteFormGroup = new FormGroup({
    title: this.title,
    preamble: this.preamble,
    content: this.content,
    target: this.target,
    display: this.display,
    publish_date: this.publish_date,
    display_until: this.display_until,
  })

  selectedSiteAnnouncements$ = this.siteAnnouncementsFacade.selectedSiteAnnouncements$.pipe(
    tap((site_announcement) => {
      if (site_announcement) this.createSiteFormGroup.patchValue(site_announcement)
    }),
  )

  constructor(private siteAnnouncementsFacade: SiteAnnouncementsFacade) {}

  private dispatchCreate(obs: SiteAnnouncementsEntity | undefined | null) {
    const site_announcement = this.createSiteFormGroup.value as Partial<SiteAnnouncementsEntity>

    if (!site_announcement.publish_date) delete site_announcement['publish_date']

    if (!site_announcement.display_until) delete site_announcement['display_until']

    if (obs)
      this.siteAnnouncementsFacade.dispatch(
        SiteAnnouncementsActions.updateSiteAnnouncement({
          site_announcement: { ...site_announcement, uuid: obs.uuid },
        }),
      )
    else
      this.siteAnnouncementsFacade.dispatch(
        SiteAnnouncementsActions.createSiteAnnouncement({
          site_announcement,
        }),
      )
  }

  submit(obs: SiteAnnouncementsEntity | undefined | null) {
    this.createSiteFormGroup.valid ? this.dispatchCreate(obs) : this.showError()
  }

  private showError() {
    this.createSiteFormGroup.markAllAsTouched()
  }
}
